export default {
      id: "unauthorized-parking-report-usage",
      viewBox: "0 0 63 63",
      url: __webpack_public_path__ + "img/icons.svg#unauthorized-parking-report",
      toString: function () {
        return this.url;
      }
    }